import * as FalsyValueHandlerHelper from './falsy-value-handler'
import * as RoutingHelper from './routing'
import * as EncryptDecrypt from './encrypt_decrypt'
import * as GeneralFilters from './filters'
import * as MenuSorter from './menuSorter'
import * as Api from './api'
import * as Transformers from './transformers'
import * as JsonKeyFinder from './translator'
import * as Validator from './validator'

export default {
  ...FalsyValueHandlerHelper,
  ...RoutingHelper,
  ...EncryptDecrypt,
  ...GeneralFilters,
  ...MenuSorter,
  ...Api,
  ...Transformers,
  ...JsonKeyFinder,
  ...Validator,
}
